/**
 * Fur & Far Launch Weekend campaign clocks.
 * Single source of timing for popup + announcement bar.
 * Australia/Brisbane (+10:00) — do not derive from the visitor's local timezone.
 *
 * Edit LAUNCH_TIME / END_TIME here when reusing for a future campaign.
 */
(function (global) {
  'use strict';

  var LAUNCH_TIME = new Date('2026-09-18T18:00:00+10:00').getTime();
  var END_TIME = new Date('2026-09-21T00:00:00+10:00').getTime();
  /** Display threshold before midnight (legacy). */
  var FREE_SHIP_BEFORE = 150;
  /** Free Australian shipping threshold from Monday 00:00 Brisbane. */
  var FREE_SHIP_AFTER = 100;

  function phase(now) {
    var t = now == null ? Date.now() : now;
    if (t >= END_TIME) return 'ended';
    if (t >= LAUNCH_TIME) return 'live';
    return 'pre';
  }

  function freeShippingThreshold(now) {
    return phase(now) === 'ended' ? FREE_SHIP_AFTER : FREE_SHIP_BEFORE;
  }

  function updateAnnouncement() {
    var el = document.querySelector('[data-ff-launch-announcement]');
    if (!el) return;

    var pre = el.getAttribute('data-pre');
    var live = el.getAttribute('data-live');
    if (pre == null && live == null) return;

    var current = phase();
    var nextText = el.getAttribute('data-standard') || '';
    if (current === 'pre' && pre != null) {
      nextText = pre || nextText;
    } else if (current === 'live' && live != null) {
      nextText = live || nextText;
    }

    if (nextText && el.textContent !== nextText) {
      el.textContent = nextText;
    }
    el.setAttribute('data-ff-phase', current);
  }

  var api = {
    LAUNCH_TIME: LAUNCH_TIME,
    END_TIME: END_TIME,
    FREE_SHIP_BEFORE: FREE_SHIP_BEFORE,
    FREE_SHIP_AFTER: FREE_SHIP_AFTER,
    phase: phase,
    freeShippingThreshold: freeShippingThreshold,
    updateAnnouncement: updateAnnouncement
  };

  global.FurFarLaunchWeekend = api;

  function startAnnouncementClock() {
    updateAnnouncement();
    if (phase() === 'ended') return;
    global.setInterval(updateAnnouncement, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAnnouncementClock);
  } else {
    startAnnouncementClock();
  }
})(typeof window !== 'undefined' ? window : this);
